module.exports = __webpack_public_path__ + "static/img/vampire_katakan.b7a6ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/vampire_katakan.png
// module id = AgeD
// module chunks = 0